import { computed, unref } from "vue";
import type { ComputedRef, Ref } from "vue";

type PageTitleInput =
  | string
  | null
  | undefined
  | Ref<string | null | undefined>
  | ComputedRef<string | null | undefined>
  | (() => string | null | undefined);

export const usePageTitle = (title: PageTitleInput) => {
  const appConfig = useAppConfig();
  const appName = String(appConfig.title || "Агропромшина B2B").trim();

  const resolveTitle = () =>
    typeof title === "function" ? title() : unref(title);

  useHead({
    title: computed(() => {
      const value = String(resolveTitle() || "").trim();
      return value ? `${value} | ${appName}` : appName;
    }),
  });
};
